import * as common from "../../events/new_calendar/common";

function renderEventPeriodData() {
    return function (periodData) {
        return common.getPeriodTextRepresentation(periodData.period_start_date, periodData.repeat_type, periodData.days_of_week, periodData.skip_repeat_period);
    };
}

export default renderEventPeriodData;